import * as React from 'react'

export default class Punch extends React.Component <{}> {
    public constructor() {
        super({})
        window.location.replace('https://wk-activity.tryweike.cn/punch/')
    }
    public render() {
        return (
            <div style={{opacity: 0}}>123</div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/views/Punch/Punch.tsx